import React, { Component } from 'react';
import './styles/qABlock.scss';
import AccordionItem from "../AccordionItem";

class QABlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showFull: false,
    };
  }

  toggleShowAll() {
    this.setState({
      showFull: !this.state.showFull
    }, () => {
      if(!this.state.showFull) {
        let elem = document.querySelector("#qaBlock");
        if(!elem) return;
        elem.scrollIntoView({ behavior: "smooth", block: "center"});
      }
    });
  }

  render() {
    const { questions } = this.props;
    if(!questions.length)
      return null;

    return (
      <section className="qaBlock" id="qaBlock">
        <div className="qaBlock__container container">
          <div className="qaBlock-cols">
            <div className="qaBlock__header">
              <h2 className="section-title">Вопросы и&nbsp;ответы</h2>
            </div>
            <div className="qaBlock__content">
              <div className="qaBlock__content__question-list question-list">
                {
                  questions.map((el, ind) => {
                    if(this.state.showFull || ind < 5) {
                      return (
                          <AccordionItem title={el.name} content={el.text} key={ind} className="question-list__item" />
                      );
                    } else {
                      return null;
                    }
                  })
                }
              </div>
              {
                questions.length > 5
                    ?
                    <div className="question-list__btn">
                      <button className="btn btn-blue--dark" onClick={this.toggleShowAll.bind(this)}>
                        {this.state.showFull ? "Скрыть" : "Показать еще"}
                      </button>
                    </div>
                    : null
              }
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default QABlock;
